import { VStack, Box } from '@chakra-ui/react'
import NoteContainer from '../components/NoteContainer'
import ModuleContainer from '../components/ModuleContainer'
import CategoryContainer from '../components/CategoryContainer'
import TaskTitle from '../components/TaskTitle'
import TaskBreadcrumb from '../components/TaskBreadcrumb'
import TaskDescription from '../components/TaskDescription'
import ExclusiveContainer from '../components/ExclusiveContainer'
import GeneralContainer from '../components/GeneralContainer'

export default function N25_11_13() {
  return (
    <NoteContainer date={'13/11/2025'} version="20.21.0">
      <VStack w="full">
        <GeneralContainer>
          <VStack w="full">
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Altura da barra de navegação lateral</TaskTitle>
                <TaskBreadcrumb>Geral</TaskBreadcrumb>
                <TaskDescription>
                  Corrigido o problema que tornava a barra de navegação lateral menor do que o tamanho total da tela em
                  alguns perfis.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </GeneralContainer>

        <ModuleContainer moduleName="SCHEDULES">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle important={true}>Comprovante de agendamento</TaskTitle>
                <TaskBreadcrumb>Agendas/ Agenda</TaskBreadcrumb>
                <TaskDescription>
                  Agora, ao criar um agendamento ou ao clicar em um agendamento já existente, é possível gerar um
                  comprovante de agendamento no formato PDF.
                </TaskDescription>
              </Box>
              <Box>
                <TaskTitle>Automação para excluir pessoa da fila</TaskTitle>
                <TaskBreadcrumb>Agendas/ Agenda/ Agendamento</TaskBreadcrumb>
                <TaskDescription>
                  Agora, ao criar um agendamento derivado de uma entrada na fila, é possível marcar a opção para excluir
                  de maneira automática a respectiva entrada na fila
                </TaskDescription>
              </Box>
            </CategoryContainer>
            <ExclusiveContainer category="ADJUSTMENTS" institutions={['teste', 'treinamento', 'novafriburgo']}>
              <CategoryContainer category="ADJUSTMENTS">
                <Box>
                  <TaskTitle>Seleção de horário obrigatória</TaskTitle>
                  <TaskBreadcrumb>Agendas/ Agenda/ Novo agendamento</TaskBreadcrumb>
                  <TaskDescription>
                    Agora, ao criar um agendamento é obrigatório a seleção de um horário
                  </TaskDescription>
                </Box>
              </CategoryContainer>
            </ExclusiveContainer>
            <CategoryContainer category="FIX">
              <Box>
                <TaskTitle>Validação do filtro do calendário</TaskTitle>
                <TaskBreadcrumb>Agendas/ Agenda</TaskBreadcrumb>
                <TaskDescription>Correção do erro que ocorria ao filtrar um intervalo de datas.</TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="ATTENDANCES">
          <VStack w="full">
            <CategoryContainer category="FEATURE">
              <Box>
                <TaskTitle>Novos filtros na recepção</TaskTitle>
                <TaskBreadcrumb>Atendimento/ Recepção/ Agendamentos</TaskBreadcrumb>
                <TaskDescription>
                  Foram adicionados novos filtros na listagem dos agendamentos: nome da pessoa, cpf da pessoa, nome da
                  agenda, nome do serviço, dia
                </TaskDescription>
              </Box>
              <ExclusiveContainer category="FEATURE" institutions={['teste', 'treinamento', 'novafriburgo']}>
                <Box>
                  <TaskTitle>Novo filtro por horário de saída</TaskTitle>
                  <TaskBreadcrumb>Atendimento/ Recepção/ Agendamentos</TaskBreadcrumb>
                  <TaskDescription>
                    Foi adicionado um novo filtro na listagem dos agendamentos: jorário de saída
                  </TaskDescription>
                </Box>
              </ExclusiveContainer>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>

        <ModuleContainer moduleName="ASSESSMENTS_AND_RESEARCH">
          <VStack w="full">
            <CategoryContainer category="ADJUSTMENTS">
              <Box>
                <TaskTitle>Formulários respondidos mais perfomáticos</TaskTitle>
                <TaskBreadcrumb>Pesquisas/ Pesquisa/ Formulários respondidos</TaskBreadcrumb>
                <TaskDescription>
                  Ajustados lógicas de performance para deixar a página mais rápida ao carregar. O tempo de listagem
                  diminuiu cerca de 70% - 80%.
                </TaskDescription>
              </Box>
            </CategoryContainer>
          </VStack>
        </ModuleContainer>
      </VStack>
    </NoteContainer>
  )
}
